import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { SidebarContent, SidebarFooter } from "@/components/ui/sidebar"

import { ChooseTranslateLanguageSelect } from "./choose-translate-language-select"
import { TranslationDictionary } from "./translation-dictionary"
import { TranslationInstructionsInput } from "./translation-instructions-input"
import { useAITranslatorSettings } from "../hooks/use-ai-translator-settings"

export function AITranslatorSettingsSidebar({ glossaryOnly = false }: { glossaryOnly?: boolean }) {
  const { t } = useTranslation()

  const { settings, resetSettings } = useAITranslatorSettings()

  return (
    <SidebarContent className="flex flex-col gap-4 overflow-hidden p-2">
      {glossaryOnly ? (
        <p className="text-sm">
          {t("translatorTool.advanced", { language: settings.selectedLanguage })}
        </p>
      ) : (
        <ChooseTranslateLanguageSelect />
      )}
      <TranslationInstructionsInput />
      <TranslationDictionary />

      <SidebarFooter className="mt-auto sm:justify-normal">
        <Button variant="destructive" onClick={resetSettings}>
          {t("pages.common.reset_settings")}
        </Button>
      </SidebarFooter>
    </SidebarContent>
  )
}
